import Country from "../../../../enums/Country";

const countryMap = {
  Russia: Country.RUSSIA,
  Germany: Country.GERMANY,
  Italy: Country.ITALY,
  Austria: Country.AUSTRIA,
  England: Country.ENGLAND,
  France: Country.FRANCE,
  Turkey: Country.TURKEY,
};

export default countryMap;
